<template>
  <div class="flex gap-1 nested-menu-tab-button-container">
    <nested-menu-tab-button :title="$t('registration_status')" icon="icon-list" route="dashboard.registration_status"></nested-menu-tab-button>
    <nested-menu-tab-button :title="$t('announcements')" icon="icon-mic" route="dashboard.announcements"></nested-menu-tab-button>
  </div>
</template>

<script>
import NestedMenuTabButton from '@/components/navigations/NestedMenuTabButton'

export default {
  name: 'Shared.Dashboard.TabNav',
  components: {
    NestedMenuTabButton
  }
}
</script>

<style scoped>

</style>
